module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"react-dom","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
 ** module id = 2
 ** module chunks = 0
 **/